module.exports = __webpack_public_path__ + "img/app-shape-1.bfcb68f0.png";